import { Component, NgZone, OnInit } from '@angular/core';
import { HttpService } from 'app/services/http.service';

@Component({
  selector: 'app-avancesmarketing',
  templateUrl: './avancesmarketing.component.html',
  styleUrls: ['./avancesmarketing.component.scss']
})
export class AvancesmarketingComponent implements OnInit {

  campaigns: any[] = [];
  campaignSelected: string;
  marketings: any[] = [];

  nombreCampaign: string;
  fechaCampaign: string;

  modoCreaEdita: boolean = false;

  constructor(
    private http: HttpService,
    private ngZone: NgZone
  ) { }

  async ngOnInit(): Promise<void> {
    this.getCampaigns()
  }

  async getCampaigns(): Promise<void> {
    console.log('getCampaigns');

    this.campaigns = await this.http.getCampaignsService();
    this.ngZone.run(() => { })
    console.log('this.campaigns', this.campaigns);

  }

  async getMarketing(): Promise<void> {
    console.log('getCampaigns');

    const aux = this.campaigns.find(e => e._id == this.campaignSelected)
    this.nombreCampaign = aux.Nombre
    this.fechaCampaign = aux.Fecha
    this.marketings = await this.http.getMarketingByCampaignsService(this.campaignSelected);

    this.marketings.forEach((mark, index) => {
      mark._accion = null
      mark.Acciones.forEach(element => {
        if (element.Accion) {
          //element.Fecha = element.Fecha.toLocaleString('es-cl')
          element.AccionCorto = element.Accion.toString().substr(0, 4) + ' ' + new Date(element.Fecha).toLocaleString('es-cl')
          if (element.Accion == 'clic')
            mark._accion = 'clic'
        }
      });
    });

    this.ngZone.run(() => { })
    console.log('this.marketings', this.marketings);

  }

}
